// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".4add1077af980f897f79590be84b09727e148ad4.chunk.bundle.js";
};